import React from 'react';
import { Box } from '@mui/material';

// Components, atoms, molecules, organisms
import ControllerElementWrapper from '../ControllerWrapper';
// Files in the same folder
import { COMPONENT_DEFINITIONS } from '../APStepContainer/definitions/components';
// Types
import { TranslateFunction } from '../../../core/types/TypographyTypes';

interface DynamicField {
    name: string;
    label: string;
    component: string;
    options?: any[];
    conditionalRender?: any;
    additionalProps?: Record<string, any>;
}

interface APFormMapperProps {
    control: any;
    errors: Record<string, any>;
    fields: DynamicField[];
    watch: (name: string) => any;
    translate: TranslateFunction;
}

const APFormMapper: React.FC<APFormMapperProps> = ({ control, errors, fields, watch, translate }) => {
    return (
        <Box>
            {fields.map((field) => {
                if (field.conditionalRender && !field.conditionalRender(watch)) {
                    return null;
                }

                const Component: React.FC<any> = COMPONENT_DEFINITIONS[field.component];

                const haveError: boolean = Boolean(errors[field.name]);

                const errorMessage = Boolean(errors[field.name]) ? errors[field.name].message : null;

                if (field.component === 'sectionHeading') {
                    return (
                        <Component
                            {...field.additionalProps}
                        >
                            {translate(field.label)}
                        </Component>
                    )
                }

                return (
                    <ControllerElementWrapper
                        key={field.name}
                        name={field.name}
                        control={control}
                        label={field.label ? translate(field.label) : ''}
                        component={Component}
                        error={haveError}
                        {...field.additionalProps}
                        helperText={haveError && errorMessage && errorMessage !== ' ' ? errorMessage : null}
                    >
                        {field.component === 'select' || field.component === 'radio' ? (
                            field.options?.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {translate(option.label)}
                                </option>
                            ))
                        ) : null}
                    </ControllerElementWrapper>
                );
            })}
        </Box>
    );
};

export default APFormMapper;
